import { useNavigate } from 'react-router';
import { ContinueButton } from '../../../../components/ContinueButton/ContinueButton';
import { ReviewSlide } from '../../../../components/ReviewSlide/ReviewSlide';
import { useUserData } from '../../../../providers/UserDataProvider/useUserData';
import styles from './ReviewSection.module.scss';
import { Spinner } from '../../../../components/Spinner/Spinner';
import { ampScreenCompleted } from '../../../../utils/AmplitudeEvents';
export const ReviewSection = ({ content, nextSlug }) => {
  const { userData } = useUserData();
  const navigate = useNavigate();
  const {slug, title,button, text, reviews } = content;
  if(!content ){
    return <Spinner />
  } 
  const gender = userData?.gender === 'Female' ? 'female' : 'male';
  const age = userData?.age || '31-35';
  const selectedReview = reviews[age]?.[gender];
  return (
    <>
      <div className={styles.wrapper}>
        {title && <div className={styles.title}>{title}</div>}
        {reviews && (
          <div className={styles.review}>
            <ReviewSlide rating={4.9} slide={selectedReview}/>
          </div>
        )}
        {text && <div className={styles.text} dangerouslySetInnerHTML={{ __html: text }} />}
      </div>
      <ContinueButton
        onClick={() => {
          ampScreenCompleted(slug,title || null)
          setTimeout(() => {
            navigate(nextSlug);
          }, 500);
        }}
      >
        {button || null}
      </ContinueButton>
    </>
  )
}
